var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.6243H6.66666C6.32499 10.6243 6.04166 10.341 6.04166 9.99935C6.04166 9.65768 6.32499 9.37435 6.66666 9.37435H13.3333C13.675 9.37435 13.9583 9.65768 13.9583 9.99935C13.9583 10.341 13.675 10.6243 13.3333 10.6243Z",
    fill: "#26B5ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 13.9577C9.65832 13.9577 9.37499 13.6743 9.37499 13.3327V6.66602C9.37499 6.32435 9.65832 6.04102 9.99999 6.04102C10.3417 6.04102 10.625 6.32435 10.625 6.66602V13.3327C10.625 13.6743 10.3417 13.9577 9.99999 13.9577Z",
    fill: "#26B5ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.9577H7.49999C2.97499 18.9577 1.04166 17.0244 1.04166 12.4993V7.49935C1.04166 2.97435 2.97499 1.04102 7.49999 1.04102H12.5C17.025 1.04102 18.9583 2.97435 18.9583 7.49935V12.4993C18.9583 17.0244 17.025 18.9577 12.5 18.9577ZM7.49999 2.29102C3.65832 2.29102 2.29166 3.65768 2.29166 7.49935V12.4993C2.29166 16.341 3.65832 17.7077 7.49999 17.7077H12.5C16.3417 17.7077 17.7083 16.341 17.7083 12.4993V7.49935C17.7083 3.65768 16.3417 2.29102 12.5 2.29102H7.49999Z",
    fill: "#26B5ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquare);
export default __webpack_public_path__ + "static/media/add-square.7bee12a8d96fcae236ef2bb7fb99e85f.svg";
export { ForwardRef as ReactComponent };